module.exports = __webpack_public_path__ + "static/media/photo-left-fourth.6c2c029e.png";